import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RouteDataService implements OnDestroy {
    private routeIdSource = new BehaviorSubject<string | null>(null);
    routeId$ = this.routeIdSource.asObservable();
    private componentDestroyed$ = new Subject<void>();

    constructor(private route: ActivatedRoute) {
        this.route.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.setRouteId(params['routeId']);
        });
    }

    setRouteId(routeId: string | null | undefined): void {
        this.routeIdSource.next(routeId);
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
